var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubAd03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_342_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9204 25.7309C25.1312 24.4327 27.1651 24.3619 28.4633 25.5727L35.4276 32.0683C36.7258 33.2791 36.7966 35.313 35.5858 36.6112C34.375 37.9093 32.341 37.9802 31.0428 36.7694L24.0785 30.2738C22.7804 29.063 22.7096 27.0291 23.9204 25.7309Z",
    fill: "#FFCACF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5314 15.6636C50.1994 16.2709 51.0591 18.1155 50.4518 19.7836L45.4294 33.5782C44.8221 35.2463 42.9775 36.1062 41.3096 35.4989C39.6415 34.8916 38.7816 33.047 39.3889 31.3789L44.4111 17.5843C45.0184 15.9162 46.863 15.0563 48.5314 15.6636Z",
    fill: "#FFCACF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42857 3.21429C6.42857 1.43908 4.98947 0 3.21429 0C1.43908 0 0 1.43908 0 3.21429V39.9279C0 39.9276 0 39.9282 0 39.9279V56.7857C0 58.5609 1.43908 60 3.21429 60H56.7857C58.5609 60 60 58.5609 60 56.7857C60 55.0106 58.5609 53.5714 56.7857 53.5714H6.42857V41.199L16.4213 30.5277C17.6346 29.232 17.5679 27.1979 16.2721 25.9845C14.9763 24.7711 12.9423 24.8379 11.7288 26.1337L6.42857 31.7938V3.21429Z",
    fill: "#FFCACF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0723 24.1292C11.0723 28.8572 14.9051 32.69 19.6331 32.69C24.3611 32.69 28.1939 28.8572 28.1939 24.1292C28.1939 19.4012 24.3611 15.5684 19.6331 15.5684C14.9051 15.5684 11.0723 19.4012 11.0723 24.1292Z",
    fill: "#F84343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0684 11.4064C41.0684 16.1365 44.903 19.971 49.6332 19.9711C54.3629 19.9711 58.1978 16.1366 58.1978 11.4064C58.1978 6.67632 54.3629 2.8418 49.6332 2.8418C44.903 2.8418 41.0684 6.67632 41.0684 11.4064Z",
    fill: "#F84343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4812 39.3527C30.4812 44.0865 34.3188 47.924 39.0526 47.924C43.7866 47.924 47.6241 44.0865 47.6241 39.3527C47.6241 34.6188 43.7866 30.7812 39.0526 30.7812C34.3188 30.7812 30.4812 34.6188 30.4812 39.3527Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAd03);
export default __webpack_public_path__ + "static/media/sub_ad_03.8b00856a77e93e4222d36b9c24118ba4.svg";
export { ForwardRef as ReactComponent };